export const SEAMS_BRAND_ASSETS = {
  mark: `${import.meta.env.BASE_URL}seams-mark.svg`,
  wordmark: `${import.meta.env.BASE_URL}seams-wordmark.svg`,
} as const;
